export const formatInvCurrency = (amount, currency = 'USD') => {
  return new Intl.NumberFormat('en-US', {
    style: 'currency', currency, minimumFractionDigits: 0, maximumFractionDigits: 0
  }).format(amount);
};

export const formatInvDate = (dateString) => {
  if (!dateString) return '-';
  return new Date(dateString).toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' });
};

export const calcProfitLoss = (investment) => {
  const currentValue = investment.current_value || investment.amount;
  const invested = investment.amount;
  const profitLoss = currentValue - invested;
  return { amount: profitLoss, percentage: ((profitLoss / invested) * 100), isPositive: profitLoss >= 0 };
};
